import api from './api';

// PWS API Service
export const pwsService = {
  // Get all PWS sections
  getPWSSctions: async (useOriginal: boolean = false) => {
    const params = useOriginal ? { original: 'true' } : {};
    const response = await api.get('/pws', { params });
    return response.data;
  },

  // Get single PWS section
  getPWSSection: async (section: string, useOriginal: boolean = false) => {
    const params = useOriginal ? { original: 'true' } : {};
    const response = await api.get(`/pws/${section}`, { params });
    return response.data;
  },

  // Get PWS subsection
  getPWSSubsection: async (section: string, subsection: string) => {
    const response = await api.get(`/pws/${section}/${subsection}`);
    return response.data;
  },

  // Get PWS page
  getPWSPage: async (section: string, subsection: string, page: string) => {
    const response = await api.get(`/pws/${section}/${subsection}/${page}`);
    return response.data;
  },

  // Get PWS statistics
  getPWSStats: async () => {
    const response = await api.get('/pws/stats/summary');
    return response.data;
  },

  // Update PWS content
  updateContent: async (pageId: string, blockIndex: number, content: string) => {
    const response = await api.put(`/pws/content/${pageId}/${blockIndex}`, { content });
    return response.data;
  }
};

export default pwsService;
